import { Info } from "lucide-react";

export function EstimateNotice() {
  return (
    <div className="flex items-center gap-3 rounded-lg bg-[#fff9e9] px-4 py-3 text-sm text-black">
      <Info className="h-4 w-4 shrink-0 fill-[#f8b400] text-[#f8b400]" aria-hidden="true" />
      <p>This is an estimate and may differ after actual weighing</p>
    </div>
  );
}
